import { Reducer } from 'redux';
import { SchoolsState, SchoolsTypes } from './types';

const INITIAL_STATE: SchoolsState = {
  schoolsList: [],
  schoolsListFull: [],
  schoolData: {
    id: '',
    name: '',
    code: '',
    document: '',
    phone: '',
    email: '',
    status: 0,
    type: 0,
    mec: false,
    createdAt: '',
    updatedAt: '',
    Addresses: [],
  },
  coursesList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<SchoolsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // LIST SCHOOLS
    case SchoolsTypes.LIST_SCHOOLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          schoolsList: INITIAL_STATE.schoolsList,
        }),
      };
    case SchoolsTypes.LIST_SCHOOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...(!action.payload?.isCsvFull && {
          schoolsList: action.payload.schoolsList,
        }),
        ...(action.payload?.isCsvFull && {
          schoolsListFull: action.payload.schoolsList,
        }),
        totalCount: action.payload.totalCount,
      };
    case SchoolsTypes.LIST_SCHOOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolsList: INITIAL_STATE.schoolsList,
      };

    // FILTER SCHOOLS
    case SchoolsTypes.FILTER_SCHOOLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolsList: INITIAL_STATE.schoolsList,
      };
    case SchoolsTypes.FILTER_SCHOOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolsList: action.payload.schoolsList,
        totalCount: action.payload.totalCount,
      };
    case SchoolsTypes.FILTER_SCHOOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolsList: INITIAL_STATE.schoolsList,
      };

    // GET SCHOOL
    case SchoolsTypes.GET_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolData: INITIAL_STATE.schoolData,
      };
    case SchoolsTypes.GET_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolData: action.payload.schoolData,
      };
    case SchoolsTypes.GET_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolData: INITIAL_STATE.schoolData,
      };

    // CREATE SCHOOL
    case SchoolsTypes.CREATE_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolData: INITIAL_STATE.schoolData,
      };
    case SchoolsTypes.CREATE_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolData: action.payload.schoolData,
      };
    case SchoolsTypes.CREATE_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolData: INITIAL_STATE.schoolData,
      };

    // UPDATE SCHOOL
    case SchoolsTypes.UPDATE_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SchoolsTypes.UPDATE_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolData: action.payload.schoolData,
      };
    case SchoolsTypes.UPDATE_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // UPDATE SCHOOL REPORT LIMIT
    case SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolData: action.payload.schoolData,
      };
    case SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // DELETE SCHOOL
    case SchoolsTypes.DELETE_SCHOOL_REQUEST:
      return { ...state, loading: true, error: false };
    case SchoolsTypes.DELETE_SCHOOL_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchoolsTypes.DELETE_SCHOOL_FAILURE:
      return { ...state, loading: false, error: true };

    // LIST COURSES
    case SchoolsTypes.LIST_COURSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        coursesList: INITIAL_STATE.coursesList,
      };
    case SchoolsTypes.LIST_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        coursesList: action.payload.coursesList,
      };
    case SchoolsTypes.LIST_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        coursesList: INITIAL_STATE.coursesList,
      };

    // CREATE COURSE
    case SchoolsTypes.CREATE_COURSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SchoolsTypes.CREATE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SchoolsTypes.CREATE_COURSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // UPDATE COURSE
    case SchoolsTypes.UPDATE_COURSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SchoolsTypes.UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SchoolsTypes.UPDATE_COURSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // DELETE COURSE
    case SchoolsTypes.DELETE_COURSE_REQUEST:
      return { ...state, loading: true, error: false };
    case SchoolsTypes.DELETE_COURSE_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchoolsTypes.DELETE_COURSE_FAILURE:
      return { ...state, loading: false, error: true };

    // FILTER COURSE
    case SchoolsTypes.FILTER_COURSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        coursesList: INITIAL_STATE.coursesList,
      };
    case SchoolsTypes.FILTER_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        coursesList: action.payload.coursesList,
        totalCount: action.payload.totalCount,
      };
    case SchoolsTypes.FILTER_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        coursesList: INITIAL_STATE.coursesList,
      };

    default:
      return state;
  }
};

export default reducer;
